import * as Types from './types';
import { createAction } from '../utils';
import { Attachment } from '../properties/types';
import { LoanType } from '@apply/constants';

export const reset = () => createAction(Types.RESET);
export const updateLoanType = (loanType: LoanType) => createAction(Types.UPDATE_LOAN_TYPE, { loanType });
export const updateConfirmEntity = (entityTypeId: number | undefined) =>
    createAction(Types.UPDATE_CONFIRM_ENTITY_TYPE, { entityTypeId });

export const updateFirstLoanApplicationWithBfi = (response: boolean) =>
    createAction(Types.UPDATE_FIRST_LOAN_APPLICATION_WITH_BFI, { response });

export const updateDefendantInLegalActions = (response: boolean) =>
    createAction(Types.UPDATE_DEFENDANT_IN_LEGAL_ACTIONS, { response });

export const updateInvolvedInJudgement = (response: boolean) => createAction(Types.UPDATE_INVOLVED_IN_JUDGEMENTS, { response });

export const updateDelinquentOnDebts = (response: boolean) => createAction(Types.UPDATE_DELINQUENT_ON_DEBTS, { response });

export const updateDelinquentOnTaxes = (response: boolean) => createAction(Types.UPDATE_DELINQUENT_ON_TAXES, { response });

export const updateFinanciallyWorseOff = (response: boolean) => createAction(Types.UPDATE_FINANCIALLY_WORSE_OFF, { response });

export const updateCurrentlyQuestionsExplanations = (explanations: string) =>
    createAction(Types.UPDATE_CURRENTLY_QUESTIONS_EXPLANATIONS, {
        explanations,
    });

export const updateHowDidYouHear = (heard: string) => createAction(Types.UPDATE_HOW_DID_YOU_HEAR, { heard });

export const updateUsingPropertyManagement = (response: boolean) =>
    createAction(Types.UPDATE_USING_PROPERTY_MANAGEMENT, { response });

export const updatePropertyManagementCompanyName = (name: string) =>
    createAction(Types.UPDATE_PROPERTY_MANAGEMENT_COMPANY_NAME, { name });

export const updatePropertyManagementCompanyWebsite = (website: string) =>
    createAction(Types.UPDATE_PROPERTY_MANAGEMENT_COMPANY_WEBSITE, { website });

export const updatePropertyManagementCompanyContactName = (name: Types.FullName) =>
    createAction(Types.UPDATE_PROPERTY_MANAGEMENT_COMPANY_CONTACT_NAME, {
        name,
    });

export const updatePropertyManagementCompanyContactEmail = (email: string) =>
    createAction(Types.UPDATE_PROPERTY_MANAGEMENT_COMPANY_CONTACT_EMAIL, {
        email,
    });

export const updatePropertyManagementCompanyContactPhone = (phone: string) =>
    createAction(Types.UPDATE_PROPERTY_MANAGEMENT_COMPANY_CONTACT_PHONE, {
        phone,
    });

export const updatePrincipalName = (name: Types.FullName) => createAction(Types.UPDATE_PRINCIPAL_NAME, { name });

export const updatePrincipalEmail = (email: string) => createAction(Types.UPDATE_PRINCIPAL_EMAIL, { email });

export const updatePrincipalSecondaryEmail = (email: string) => createAction(Types.UPDATE_PRINCIPAL_SECONDARY_EMAIL, { email });

export const updatePrincipalPhone = (phone: string) => createAction(Types.UPDATE_PRINCIPAL_PHONE, { phone });

export const updateBorrowerId = (id: number) => createAction(Types.UPDATE_BORROWER_ID, { id });

export const updateMasterNoteId = (masterNoteId: number) => createAction(Types.UPDATE_BORROWER_MASTERNOTEID, { masterNoteId });

export const updateEntityId = (id: number) => createAction(Types.UPDATE_ENTITY_ID, { id });

export const updateEntityName = (entity: string) => createAction(Types.UPDATE_ENTITY_NAME, { entity });

export const updateEntityStateIncorporated = (stateIncorporated: string) =>
    createAction(Types.UPDATE_ENTITY_STATE_INCORPORATED, { stateIncorporated });

export const updateEntityAddressStreet1 = (street1: string) => createAction(Types.UPDATE_ENTITY_ADDRESS_STREET1, { street1 });

export const updateEntityAddressStreet2 = (street2: string) => createAction(Types.UPDATE_ENTITY_ADDRESS_STREET2, { street2 });

export const updateEntityAddressCity = (city: string) => createAction(Types.UPDATE_ENTITY_ADDRESS_CITY, { city });

export const updateEntityAddressState = (state: string) => createAction(Types.UPDATE_ENTITY_ADDRESS_STATE, { state });

export const updateEntityAddressZipcode = (zipCode: string) => createAction(Types.UPDATE_ENTITY_ADDRESS_ZIPCODE, { zipCode });

export const updateContactInfoSameAsPropertyContact = (response: boolean) =>
    createAction(Types.UPDATE_CONTACT_INFO_SAME_AS_PROPERTY, { response });

export const replaceBorrowerState = (borrower: Types.BorrowerState) => createAction(Types.REPLACE_BORROWER_STATE, { borrower });

export const updateBorrowerFirstLoan = (isFirstLoan: boolean) =>
    createAction(Types.UPDATE_BORROWER_INFO_FIRSTLOAN, { isFirstLoan });

export const updateBorrowerShouldAskLegalQuestions = (shouldAskLegalQuestions: boolean) =>
    createAction(Types.UPDATE_BORROWER_INFO_SHOULDASKLEGAL, {
        shouldAskLegalQuestions,
    });

export const updateIsDirty = (isDirty: boolean) => createAction(Types.UPDATE_IS_DIRTY, { isDirty });

export const updateEsign = (esign: Types.Esign) => createAction(Types.UPDATE_ESIGN, { esign });

export const updateApiId = (apiId: string, token?: string) => createAction(Types.UPDATE_API_ID, { apiId, token });

export const updateGuestAcknowledgedNoPersonalLoans = (response: boolean) =>
    createAction(Types.GUEST_ACKNOWLEDGED_NO_PERSONAL_LOANS, { response });

export const updateManagementAgreement = (guid: string, value: Attachment) =>
    createAction(Types.UPDATE_MANAGEMENT_AGREEMENT, { guid, value });

export const updateFinalizeThirdPartyClaim = (state: string) => createAction(Types.UPDATE_FINALIZE_THIRD_PARTY_CLAIM, { state });

export const updateFinalizePartyName = (state: string) => createAction(Types.UPDATE_FINALIZE_THIRD_PARTY_NAME, { state });

export type BorrowerActionReturns =
    | ReturnType<typeof reset>
    | ReturnType<typeof updateLoanType>
    | ReturnType<typeof updateConfirmEntity>
    | ReturnType<typeof updateFirstLoanApplicationWithBfi>
    | ReturnType<typeof updateHowDidYouHear>
    | ReturnType<typeof updateInvolvedInJudgement>
    | ReturnType<typeof updateDelinquentOnDebts>
    | ReturnType<typeof updateDelinquentOnTaxes>
    | ReturnType<typeof updateFinanciallyWorseOff>
    | ReturnType<typeof updateCurrentlyQuestionsExplanations>
    | ReturnType<typeof updateDefendantInLegalActions>
    | ReturnType<typeof updateUsingPropertyManagement>
    | ReturnType<typeof updatePropertyManagementCompanyName>
    | ReturnType<typeof updatePropertyManagementCompanyWebsite>
    | ReturnType<typeof updatePropertyManagementCompanyContactName>
    | ReturnType<typeof updatePropertyManagementCompanyContactEmail>
    | ReturnType<typeof updatePropertyManagementCompanyContactPhone>
    | ReturnType<typeof updateContactInfoSameAsPropertyContact>
    | ReturnType<typeof updatePrincipalName>
    | ReturnType<typeof updatePrincipalEmail>
    | ReturnType<typeof updatePrincipalPhone>
    | ReturnType<typeof updateEntityName>
    | ReturnType<typeof updateEntityAddressStreet1>
    | ReturnType<typeof updateEntityAddressStreet2>
    | ReturnType<typeof updateEntityAddressCity>
    | ReturnType<typeof updateEntityAddressState>
    | ReturnType<typeof updateEntityAddressZipcode>
    | ReturnType<typeof replaceBorrowerState>
    | ReturnType<typeof updateIsDirty>
    | ReturnType<typeof updateEsign>
    | ReturnType<typeof updateApiId>
    | ReturnType<typeof updateGuestAcknowledgedNoPersonalLoans>
    | ReturnType<typeof updateManagementAgreement>
    | ReturnType<typeof updateFinalizeThirdPartyClaim>
    | ReturnType<typeof updateFinalizePartyName>;
